<template>
    <div class="bank-selections">
        <BankSelectionDetailsModal :show_bank_details.sync="modals.show_bank_details" :bank="view_bank" />
        <CompareBanksModal :compare_banks.sync="modals.compare_banks" :banks="multipleSelection" :product_selected="'pl'" />

        <p class="text-right text-muted text-xs mb-2">
            Banks marked with
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
                <path fill="#F3BC43"
                    d="M316.9 18c-5.3-11-16.5-18-28.8-18s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329l-24.6 145.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329l104.2-103.1c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7l-143.7-21.2L316.9 18z" />
            </svg>
            are recommendation
        </p>
        <!-- Checkbox only eligible -->
        <div class="d-flex justify-content-end">
            <b-col cols="12">
                <el-checkbox  class="mb-2" v-model="onlyEligible" @change="filterEligibleBanks">Only Eligible</el-checkbox>
            </b-col>
            
        </div>
        <div class="card-table">
            <el-alert v-if="multipleSelection.length > 0" class="compare-banks" effect="dark" @close="emptySelection">
                <b-row>
                    <b-col cols="4" md="auto" class="bg-white rounded mx-2 p-2 mb-2 mb-md-0" align-self="center"
                        v-for="(bank, index) in multipleSelection" :key="index">
                        <el-image style="height: 18px;" :src="bank.bank_image_url" fit="contain">
                            <template #error>
                                <div class="image-slot">
                                    <span class="text-dark text-xs text-truncate px-md-4 px-2 pt-1">{{ bank.bank_name
                                        }}</span>
                                </div>
                            </template>
                        </el-image>
                    </b-col>
                    <b-col cols="6" md="auto" class="border-left text-center" align-self="center">
                        <b-button variant="primary" class="mb-1" @click="compareBanks">Compare</b-button>
                        <div>{{ multipleSelection.length }} banks selected (Max. 5)</div>
                    </b-col>
                </b-row>
            </el-alert>
            <el-table ref="multipleTable" :data="tableData" style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column width="30">
                    <template slot-scope="scope">
                        <svg v-if="scope.row.is_recommended" xmlns="http://www.w3.org/2000/svg" width="16" height="12"
                            viewBox="0 0 576 512">
                            <path fill="#F3BC43"
                                d="M316.9 18c-5.3-11-16.5-18-28.8-18s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329l-24.6 145.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329l104.2-103.1c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7l-143.7-21.2L316.9 18z" />
                        </svg>
                    </template>
                </el-table-column>
                <el-table-column v-if="checkIsCorporatePackageSubscription()" type="selection" width="55">
                </el-table-column>
                <el-table-column prop="bank_name" label="Bank Name" min-width="90">
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-image style="height: 40px;" :src="scope.row.bank_image_url" fit="contain">
                            <template #error>
                                <div class="image-slot">
                                    <span class="d-inline-block text-truncate" style="max-width: 90px;">{{
                                        scope.row.bank_name }}</span>
                                </div>
                            </template>
                        </el-image>
                    </template>
                </el-table-column>

                <el-table-column label="Min/Max Loan Amount" min-width="130">
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">RM {{ scope.row.bank_min_loan_amount | moneyFormatter }}</p>
                        <p class="top-line">RM {{ scope.row.bank_max_loan_amount | moneyFormatter }}</p>
                    </template>
                </el-table-column>
                <el-table-column v-if="_gHlp.checkAccess(['c_customer__personal_loan_eligible'])" label="DSR Eligibility" min-width="130">
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">RM {{ scope.row.bank_loan_eligibility_amount < 0 ? 0 : scope.row.bank_loan_eligibility_amount | moneyFormatter }}</p>
                    </template>
                </el-table-column>

                <el-table-column v-if="_gHlp.checkAccess(['c_customer__personal_loan_eligible'])" label="Eligible Amount" min-width="130">
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">RM {{ parseFloat(scope.row.bank_loan_eligibility_amount) > parseFloat(scope.row.bank_max_loan_amount) && parseFloat(scope.row.bank_loan_eligibility_amount) > 0 ? scope.row.bank_max_loan_amount : (scope.row.bank_loan_eligibility_amount < 0 ? 0 : scope.row.bank_loan_eligibility_amount) | moneyFormatter }}</p>
                    </template>
                </el-table-column>

                <el-table-column v-if="_gHlp.checkAccess(['c_customer__personal_loan_eligible'])" label="Pre-Status" min-width="130">
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p v-if="scope.row.bank_loan_eligibility_amount <= 0" class="top-line" style="color:red">Not Eligible</p>
                        <p v-if="scope.row.bank_loan_eligibility_amount > 0" class="top-line" style="color:green">Eligible</p>
                    </template>
                </el-table-column>

                <el-table-column prop="est_interest_rate" label="Est Interest Rate" min-width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">{{ scope.row.bank_loan_interest_rate }}% p.a</p>
                    </template>
                </el-table-column>
                <el-table-column prop="tenure" label="Tenure" min-width="90">
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">{{ scope.row.bank_loan_tenure_year }} years</p>
                    </template>
                </el-table-column>
                <el-table-column label="Bank Details" min-width="90">
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-button type="text" @click="showBankDetails(scope.row)">View</el-button>
                    </template>
                </el-table-column>
                <el-table-column min-width="150">
                    <template slot-scope="scope">
                        <b-button class="m-2" variant="primary"
                            @click="emitEvent('show-personal-loan-selection', scope.row)">Apply</b-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Button, Image, Alert, Checkbox } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import BankSelectionDetailsModal from '@/views/CustomerProfile/CustomerModals/SolutionScenarioModals/BankSelectionDetailsModal'
import CompareBanksModal from '@/views/CustomerProfile/CustomerModals/SolutionScenarioModals/CompareBanksModal'
import {
    helperFunctionMixin,
    notifyFunctionMixin,
    axios,
    services,
    getHeader
} from '@/assets/js/httpImports.js'
import { useProductStore } from '@/stores/productStore'
import { useAuthStore } from '@/stores/authStore'
import { useCustomerStore } from '@/stores/customerStore'
import { mapState } from 'pinia'

export default {
    components: {
        BankSelectionDetailsModal,
        CompareBanksModal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Button.name]: Button,
        [Image.name]: Image,
        [Alert.name]: Alert,
        [Checkbox.name]: Checkbox,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    data() {
        return {
            tableData: [],
            modals: {
                show_bank_details: false,
                compare_banks: false
            },
            view_bank: null,
            multipleSelection: [],
            selected_bank: [],
            onlyEligible: false,
        }
    },
    created() {
        this.getPersonalLoanBanks()
    },
    computed: {
        ...mapState(useAuthStore, ['auth_user']),
        ...mapState(useCustomerStore, ['current_eligibility_pl']),
    },
    watch: {
        current_eligibility_pl: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.getPersonalLoanBanks()
                }
            }
        }
    },
    methods: {
        filterEligibleBanks() {
            if (this.onlyEligible) {
                this.tableData = this.tableData.filter((bank) => bank.bank_loan_eligibility_amount > 0)
            } else {
                this.getPersonalLoanBanks()
            }
        },
        getPersonalLoanBanks() {
            this.tableData =this.current_eligibility_pl.bank_eligibilities
            const limit = this.auth_user.subscription.privileges.scpk_limit_bank
            const prefferedBanks = this.auth_user.subscription.scrb_banks
            if (prefferedBanks.length > 0) {
                const newTableData = []
                this.tableData.forEach((bank, index) => {
                    if (prefferedBanks.find((item) => item.bank_code === bank.bank_code)) {
                        this.tableData[index].is_recommended = true
                        newTableData.push(this.tableData[index])
                    }
                })
                if (newTableData.length) {
                    this.tableData = newTableData
                } else {
                    if (limit) {
                        this.tableData.length = limit
                    }
                }
            } else {
                if (limit) {
                    this.tableData.length = limit
                }
            }
            // sort by recommended
            this.tableData.sort((a, b) => a.is_recommended === b.is_recommended ? 0 : a.is_recommended ? -1 : 1)
        },
        emitEvent(eventName, bank) {
            useProductStore().$patch((state) => {
                state.current_product_data = { ...state.current_product_data, banks: [bank] }
            })
            solutionEventBus.$emit(eventName)
        },
        showBankDetails(bank) {
            this.modals.show_bank_details = true
            this.view_bank = bank
        },
        handleSelectionChange(val) {
            if (val.length <= 5) {
                this.multipleSelection = val
            }
        },
        emptySelection() {
            this.$refs.multipleTable.clearSelection()
        },
        compareBanks() {
            this.modals.compare_banks = true
        }
    }
}
</script>